import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import './ConfirmEmail.css';
import { isErrorResponse } from '../../types/ErrorResponse';
import Spinner from '../../shared/Spinner';

const ConfirmEmail = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const [confirming, setConfirming] = useState(true);
  const { confirmEmail } = useAuth();
  const navigate = useNavigate();
  const hasConfirmed = useRef(false);

  useEffect(() => {
    if (hasConfirmed.current) {
      return;
    }
    hasConfirmed.current = true;

    const userId = searchParams.get('userId');
    const confirmationCode = searchParams.get('confirmationCode');

    if (!userId || !confirmationCode) {
      setError('Invalid confirmation link. Please check your email and try again.');
      setConfirming(false);
      return;
    }

    const confirm = async () => {
      try {
        await confirmEmail(userId, confirmationCode);
        // Successfully confirmed, navigate to chat
        navigate('/chat');
      } catch (err: unknown) {
        if (isErrorResponse(err)) {
          setError(err.message);
        } else {
          setError('Email confirmation failed');
        }
        setConfirming(false);
      }
    };

    confirm();
  }, [searchParams, confirmEmail, navigate]);

  return (
    <>
      <div className="container py-5 confirm-page">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <div className="card shadow-sm">
              <div className="card-body p-4">
                {confirming ? (
                  <>
                    <Spinner
                      visible={true}
                      ariaLabel="Confirming your email..."
                      text="Please wait while we verify your account..."
                    />
                  </>
                ) : (
                  <>
                    <h2>Confirmation Failed</h2>
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                    <div className="text-center">
                      <button className="btn btn-primary" onClick={() => navigate('/login')}>
                        Back to Login
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmEmail;
